import { render } from "./MatchmakerSingleChoiceStep.vue?vue&type=template&id=5f5c914a"
import script from "./MatchmakerSingleChoiceStep.vue?vue&type=script&lang=js"
export * from "./MatchmakerSingleChoiceStep.vue?vue&type=script&lang=js"

import "./MatchmakerSingleChoiceStep.vue?vue&type=style&index=0&id=5f5c914a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__